<template>
    <div>
        <div class="box box--white ssv-course-header">
            <div class="ssv-course-header__name">
              <h3>{{prepareTitle()}}</h3>
                <p>
                    Po zaslání objednávky se s Vám spojíme a vyřešíme všechny detaily.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import moment from 'moment';

    export default {
        name:     'SsvOrderHeaderSchoolExcursion',
        computed: {
            ...mapGetters('ssvOrder', ['course', 'courseDate', 'trainingCenter']),
            formatDate() {
                const { dateOfEvent } = this.courseDate;
                return moment(dateOfEvent).format('DD. MM. YYYY');
            }
        },
        methods: {
            prepareTitle(){
                const {withoutFixedDate, name} = this.course;
                if (withoutFixedDate) return name;

                return `${this.formatDate} - ${name}`;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/header/HeaderSchoolExcursion.vue